// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "", ""]);
// Exports
exports.locals = {
	"primaryColor": "var(--primary-color)",
	"elementPrimary": "var(--primary-color)",
	"menuText": "#bfcbd9",
	"menuActiveText": "#FFF",
	"subMenuActiveText": "#f4f4f5",
	"menuBg": "#001529",
	"menuHover": "#263445",
	"subMenuBg": "#000c17",
	"subMenuHover": "#001528",
	"sideBarWidth": "240px"
};
module.exports = exports;
